import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-field-tooltip-suffix',
  templateUrl: './field-tooltip-suffix.component.html',
  styleUrls: ['./field-tooltip-suffix.component.scss']
})
export class FieldTooltipSuffixComponent implements OnInit {
    _tooltip?: string;
    @Input() set tooltip(v : string){
        this._tooltip = v;
        console.log("New tooltip: ", v);
    }
    
    constructor() { }

    ngOnInit(): void {
    }

}
